import type { CSSProperties } from 'react';

interface SkeletonProps {
  width?: string;
  height?: string;
  borderRadius?: string;
  style?: CSSProperties;
  count?: number;
}

export function Skeleton({
  width = '100%',
  height = '1rem',
  borderRadius = 'var(--radius-md)',
  style,
  count = 1,
}: SkeletonProps) {
  return (
    <>
      {Array.from({ length: count }, (_, i) => (
        <div
          key={i}
          role="status"
          aria-label="Loading..."
          style={{
            width,
            height,
            borderRadius,
            background: `linear-gradient(
              90deg,
              var(--color-bg-secondary) 25%,
              var(--color-border-subtle) 37%,
              var(--color-bg-secondary) 63%
            )`,
            backgroundSize: '200% 100%',
            animation: 'shimmer 1.5s ease-in-out infinite',
            marginBottom: count > 1 && i < count - 1 ? 'var(--space-3)' : undefined,
            ...style,
          }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
      ))}
    </>
  );
}

export function SkeletonCard() {
  return (
    <div
      style={{
        background: 'var(--color-surface-glass)',
        backdropFilter: 'blur(var(--glass-blur))',
        border: '1px solid var(--color-surface-glass-border)',
        borderRadius: 'var(--radius-xl)',
        padding: 'var(--space-6)',
      }}
    >
      <Skeleton height="1.5rem" width="60%" style={{ marginBottom: 'var(--space-4)' }} />
      <Skeleton height="0.875rem" count={3} />
      <div style={{ display: 'flex', gap: 'var(--space-3)', marginTop: 'var(--space-4)' }}>
        <Skeleton width="80px" height="2rem" borderRadius="var(--radius-full)" />
        <Skeleton width="80px" height="2rem" borderRadius="var(--radius-full)" />
      </div>
    </div>
  );
}
